/*
  Cart-Upsell Quick-Add — direkter „In den Warenkorb" je Drawer-Upsell-Item.

  Spiegelt product-atc-drawer-trautis.js: POST window.routes.cart_add_url mit
  id + quantity + sections (aus cart.getSectionsToRender) + sections_url, danach
  cart.renderContents(data) → Drawer (inkl. Upsell) re-rendert und bleibt offen.
  PUB_SUB cartUpdate bei Erfolg, cartError + /cart-Fallback bei sold-out/race.

  Nur EINDEUTIGE Varianten bekommen ein <button data-upsell-add data-variant-id>;
  Multi-Variant-Items verlinken stattdessen auf die PDP (Optionen wählen) und haben
  KEIN data-upsell-add → werden hier nicht behandelt (normaler Link-Klick).

  Delegierter Klick auf document überlebt das Drawer-Re-Render (die Buttons werden
  bei jedem Cart-Change neu gerendert). Sichtbar nur im Drawer (CSS-Scope
  cart-drawer .t-cart-upsell__add); auf /cart ist das Control ausgeblendet.
*/
(function (root, factory) {
  var api = factory(typeof window !== 'undefined' ? window : null);
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) {
    root.TrautisCartUpsellAdd = api;
    if (root.document && root.document.addEventListener) {
      if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', api.init);
      else api.init();
    }
  }
})(typeof window !== 'undefined' ? window : this, function (win) {
  'use strict';

  function getDrawer() {
    return win.document && win.document.querySelector ? win.document.querySelector('cart-drawer') : null;
  }

  function quickAdd(btn) {
    if (!btn || (btn.getAttribute && btn.getAttribute('data-loading'))) return Promise.resolve();
    var variantId = btn.dataset ? btn.dataset.variantId : null;
    if (!variantId) return Promise.resolve();
    var cart = getDrawer();
    if (!cart || typeof cart.renderContents !== 'function') return Promise.resolve();

    if (btn.setAttribute) btn.setAttribute('data-loading', '1');

    var formData = new win.FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    var ids = cart.getSectionsToRender().map(function (s) { return s.id; });
    formData.append('sections', ids.join(','));
    formData.append('sections_url', (win.location && win.location.pathname) || '/');
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);

    var addUrl = (win.routes && win.routes.cart_add_url) || '/cart/add';
    return win.fetch(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          // sold-out / Inventar-Race → sichere Eskalation auf die Warenkorb-Seite.
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'cart-upsell-add',
              productVariantId: variantId,
              errors: data.errors || data.description,
              message: data.message
            });
          }
          if (btn.removeAttribute) btn.removeAttribute('data-loading');
          win.location = (win.routes && win.routes.cart_url) || '/cart';
          return data;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-upsell-add',
            productVariantId: variantId,
            cartData: data
          });
        }
        // is-empty lebt auf <cart-drawer> selbst; vor render/open entfernen, sonst
        // bleibt das Empty-Layout stehen (vgl. product-atc-drawer-trautis.js).
        if (cart.classList && cart.classList.remove) cart.classList.remove('is-empty');
        cart.renderContents(data); // #CartDrawer + #cart-icon-bubble neu, dann open()
        return data;
      })
      .catch(function () {
        if (btn.removeAttribute) btn.removeAttribute('data-loading');
        // Netzfehler → nicht stranden: zur PDP der Karte, dort kann manuell hinzugefügt werden.
        var cell = btn.closest ? btn.closest('.t-cart-upsell__cell') : null;
        var link = cell && cell.querySelector ? cell.querySelector('a.t-cart-upsell__card') : null;
        if (link && link.href) win.location = link.href;
      });
  }

  function onClick(evt) {
    var t = evt.target;
    var btn = t && t.closest ? t.closest('button[data-upsell-add]') : null;
    if (!btn) return;
    evt.preventDefault();
    quickAdd(btn);
  }

  var bound = false;
  function init() {
    if (!win || !win.document || bound) return;
    bound = true;
    win.document.addEventListener('click', onClick);
  }

  return { init: init, quickAdd: quickAdd, onClick: onClick };
});
